/**
 * Created by Ramon Wenger on 27.06.18.
 * Copyright (c) 2018 Iterativ GmbH. All rights reserved.
 */
import { Component } from "@angular/core";


@Component({
    selector: 'hc-accept-terms',
    template: `
        <div class="page accept-terms">
            <div class="page__header">
                <hc-simple-header></hc-simple-header>

            </div>
            <div class="page__content accept-terms__content">
                <p>{{'Im November 2019 wurden die Datenschutzbestimmungen für Helloclass angepasst. Damit du Helloclass weiterhin nutzen kannst, muss dein Schuladministrator die Datenschutzbestimmungen akzeptieren. Bitte kontaktiere deinen Schuladministrator.' | translate}}</p>
            </div>
        </div>
    `
})
export class AcceptTermsPage {

}
